import smoothscroll from 'smoothscroll-polyfill';

export default {
    _header: null,
    _scroll: null,
    _main: null,
    init() {
        this._main = document.querySelector('[data-main]');
        this._scroll = document.querySelectorAll('[data-scroll]');

        if (!this._scroll) {
            return;
        }

        smoothscroll.polyfill();
        for( const scroll of this._scroll){
            scroll.addEventListener('click', (e) => {
                const targetRef = scroll.getAttribute('data-scroll');
                if(targetRef !==  null && targetRef !==  " " && document.querySelector(targetRef) !== null  && document.querySelector(targetRef) !== " " ){
                    const target = document.querySelector(targetRef);
                    target.scrollIntoView({ behavior: 'smooth',block: 'start'});
                }else{
                    this._main.scrollIntoView({ behavior: 'smooth'});
                }
            });
        }
    }
}